import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./SupermarketProduct.module.css";
import { faImages } from "@fortawesome/free-regular-svg-icons";
import Resizer from "react-image-file-resizer";
import Select from "react-select";
import "./SupermarketProduct.css";
import {
  AddBrandPostApi,
  AddProductSuppermarketAPI,
  getBrandListApi,
  getSearchProductsApi,
} from "../../../Api/SupplierServices";
import { errorToast, succToast } from "../../../Utils/Toast/Toast";
import { useForm } from "react-hook-form";
import MenuTitle from "../../MenuTitlle/MenuTitle";
import LoadingComponet from "../../../Components/LoadingComponet/LoadingComponet";
import { faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../Modal/Modal";
const SupermarketProductContainer = () => {
  const [files, setFiles] = useState([]);
  const [brands, setBrands] = useState([]);
  const [chooseProduct, setChooseProduct] = useState("");
  const [englishbrand, setEnglishbrand] = useState([]);
  const [persianbrand, setPersianbrand] = useState([]);
  const [chooseBrand, setChooseBrand] = useState();
  const [disable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [,setAddNewProduct] = useState(true);
  const [,setAddExistProduct] = useState(true);
  const [isBigImg, setIsBigImg] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showSearchPart, setShowSearchPart] = useState(false);
  const [onclickPlus, setOnclickPlus] = useState(false);
  const [onclickLi, setOnclickLi] = useState(false);
  const [imgName, setImgName] = useState();
  const [searchValue, setSearchValue] = useState([]);
  const [productInput, setProductInput] = useState("");
  const [productId, setProductId] = useState();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    getBrandList();
    getSearchProduct();
    if (onclickPlus) {
      setAddNewProduct(false);
    } else if (onclickLi) {
      setAddExistProduct(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getBrandList = async () => {
    const result = await getBrandListApi();
    setBrands(result.brand);
  };

  let brandOption =
    brands &&
    brands.map((item) => {
      return { value: item.id, label: item.brand_persian };
    });

  ////////////حذف عکس
  const removeImage = (name) => {
    const newList = files.filter((item) => item !== name);
    setFiles(newList);
  };
  ///////////////نمایش بزرگتر عکس
  const showBigPic = (img) => {
    setIsBigImg(true);
    setImgName(img);
  };

  const UploadImage = async (images) => {
    return await resizeFile(images);
  };

  const resizeFile = (file) => {
    for (let i = 0; i < file.length; i++) {
      Resizer.imageFileResizer(
        file[i],
        1024,
        1024,
        "WEBP",
        100,
        0,
        (uri) => {
          setFiles((prevfiles) => [...prevfiles, uri]);
        },
        "base64"
      );
    }
  };

  const onSubmit = (data,e) => {
    // console.log(e.target)
    setLoading(true);
    setDisable(true);
    let info = null;
    if (onclickLi) {
      info = {
        price: data.price === "" ? 0 : data.price,
        count: data.count === "" ? 0 : data.count,
        max_count: data.maxCount === "" ? 0 : data.maxCount,
        off_price: data.off ? data.off : 0,
        new: "0",
        product_id: productId,
      };
    } else if (onclickPlus) {
      info = {
        file: files,
        name: chooseProduct,
        barcode_1: data.barcode1 === "" ? 0 : parseInt(data.barcode1),
        barcode_2: data.barcode2 === "" ? 0 : parseInt(data.barcode2),
        barcode_3: data.barcode3 === "" ? 0 : parseInt(data.barcode3),
        price: data.price === "" ? 0 : data.price,
        count: data.count === "" ? 0 : data.count,
        max_count: data.maxCount === "" ? 0 : data.maxCount,
        other_detail: data.maxCount === "" ? "" : data.describe,
        category_id: 27,
        off_price: data.off ? data.off : 0,
        new: "1",
        brand_id: parseInt(chooseBrand.value),
        weight: data.weight === "" ? 0 : parseInt(data.weight),
        volume: data.volume === "" ? 0 : parseInt(data.volume),
        category_free: 0,
      };
    }
    AddProductSuppermarketAPI(info, (res) => {
      if (res.status === 0) {
        setProductInput('')
        errorToast(res.message);
        setLoading(false);
        setDisable(false);
        e.target.reset();
      } else {
        e.target.reset();
        succToast(res.message);
        setProductInput('')
        setLoading(false);
        setDisable(false);
      }
    });
  };

  const AddBrandHandler = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const sendNewBrand = () => {
    let info = {
      brand_persian: persianbrand,
      brand_english: englishbrand,
      file: "",
    };
    AddBrandPostApi(info, (res) => {
      if (res.status === 1) {
        succToast(res.message);
        setEnglishbrand("");
        setPersianbrand("");
      } else {
        errorToast("خطایی رخ داده است");
        setEnglishbrand("");
        setPersianbrand("");
      }
    });
    getBrandList();
  };
  ////search product/////////
  const getSearchProduct = async (value) => {
    // console.log(value);
    setProductInput(value);
    setSearchValue([]);
    let result;
    setChooseProduct(value);
    if (result) {
      result.abort();
    } else {
      if (value) {
        result = await getSearchProductsApi(value);
        const sortedResult = result.product.sort((a, b) => {
          if (a.score > b.score) {
            return -1;
          } else if (a.sscore < b.score) {
            return 1;
          } else return 0;
        });
        setSearchValue(sortedResult);
        if (result.product.length === 0 || value===null) {
          setShowSearchPart(false);
        } else {
          setShowSearchPart(true);
        }
      } else {
        return;
      }
    }
  };
  const clickProductHandler = (value) => {
    setProductId(value.id);
    setProductInput(value.name);
    setShowSearchPart(false);
    setOnclickPlus(false);
    setOnclickLi(true);
  };
  ////////////random number for image////////////////
  // function randomNumberInRange(min, max) {
  //   return Math.floor(Math.random() * (max - min + 1)) + min;
  // }
  let clickHandler = null;
  if (onclickLi) {
    clickHandler = (
      <>
        <input
          {...register("maxCount", { required: true })}
          className={errors.maxCount ? Style.errorInput : Style.fileInputPart2}
          placeholder={"حداکثر تعداد"}
          type="text"
        />
        <input
          {...register("price", { required: true })}
          className={errors.price ? Style.errorInput : Style.fileInputPart2}
          placeholder={"قیمت به تومان"}
          type="text"
        />
        <input
          {...register("off")}
          className={errors.off ? Style.errorInput : Style.fileInputPart2}
          placeholder={"قیمت با تخفیف به تومان"}
          type="text"
        />
        <input
          {...register("count", { required: true })}
          className={errors.count ? Style.errorInput : Style.fileInputPart2}
          placeholder={"تعداد"}
          type="text"
        />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            ثبت
          </button>
        </div>
      </>
    );
  } else if (onclickPlus) {
    clickHandler = (
      <>
        <div className={Style.imagePart}>
          {files.map((item, index) => {
            return (
              <div key={index} className={Style.eachImage}>
                <div
                  className={Style.picHolder}
                  onClick={() => showBigPic(item)}
                >
                  <img src={`${item}`} alt="" />
                </div>
                <div
                  className={Style.iconHolder}
                  onClick={() => removeImage(item)}
                >
                  <FontAwesomeIcon icon={faTrashAlt} />
                </div>
              </div>
            );
          })}
        </div>
        <div className={Style.inptFileHolder}>
          <label className={Style.lablePart} htmlFor="imgSelect">
            <FontAwesomeIcon icon={faImages} />
          </label>
          <p className={Style.placeHolderInput}>بارگذاری تصویر</p>
          <input
            {...register("pic")}
            className={Style.fileInputPart}
            type="file"
            id={"imgSelect"}
            onChange={(e) => UploadImage(e.target.files)}
            multiple
          />
        </div>
        <div className={Style.selectHolder}>
          <FontAwesomeIcon
            icon={faPlus}
            className={Style.plusIcon}
            onClick={AddBrandHandler}
          />
          <Select
            {...register("brand")}
            onChange={setChooseBrand}
            className={Style.selectOptionsearch}
            placeholder={"برند محصول"}
            options={brandOption}
          />
        </div>

        <input
          {...register("weight")}
          className={Style.fileInputPart2}
          placeholder={"وزن به گرم"}
        />
        <input
          {...register("volume")}
          className={Style.fileInputPart2}
          placeholder={"حجم به میلی لیتر"}
        />

        <input
          {...register("barcode1")}
          className={Style.fileInputPart2}
          placeholder={"بارکد شماره یک"}
        />
        <input
          {...register("barcode2")}
          className={Style.fileInputPart2}
          placeholder={"بارکد شماره دو"}
          type="text"
        />
        <input
          {...register("barcode3")}
          className={Style.fileInputPart2}
          placeholder={"بارکد شماره سه"}
          type="text"
        />

        <input
          {...register("maxCount", { required: true })}
          className={errors.maxCount ? Style.errorInput : Style.fileInputPart2}
          placeholder={"حداکثر تعداد"}
          type="text"
        />
        <input
          {...register("price", { required: true })}
          className={errors.price ? Style.errorInput : Style.fileInputPart2}
          placeholder={"قیمت به تومان"}
          type="text"
        />
        <input
          {...register("off")}
          className={errors.off ? Style.errorInput : Style.fileInputPart2}
          placeholder={"قیمت با تخفیف به تومان"}
          type="text"
        />
        <input
          {...register("count", { required: true })}
          className={errors.count ? Style.errorInput : Style.fileInputPart2}
          placeholder={"تعداد"}
          type="text"
        />
        <textarea
          {...register("describe")}
          placeholder={"توضیحات تکمیلی"}
          className={Style.fileInputArea}
        />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            ثبت
          </button>
        </div>
      </>
    );
  }
  return (
    <div className={Style.componentHolder}>
      <Modal show={openModal} modalClose={handleCloseModal} translate={40}>
        <div className={Style.FormAddProduct}>
          <input
            className={Style.fileInputPart2}
            placeholder={"نام برند به فارسی "}
            onChange={(e) => setPersianbrand(e.target.value)}
            value={persianbrand}
          />
          <input
            className={Style.fileInputPart2}
            placeholder={"نام برند به انگلیسی"}
            onChange={(e) => setEnglishbrand(e.target.value)}
            value={englishbrand}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "50%",
            }}
          >
            <button
              className={Style.btnStyle}
              type={"submit"}
              onClick={sendNewBrand}
            >
              ثبت
            </button>
            <button
              className={Style.btnStyle}
              type={"submit"}
              onClick={handleCloseModal}
            >
              بستن
            </button>
          </div>
        </div>
      </Modal>

      {loading ? <LoadingComponet /> : null}

      <MenuTitle title={"افزودن محصول"} />

      {isBigImg ? (
        <div className={Style.bigImg} onClick={() => setIsBigImg(false)}>
          <img src={`${imgName}`} alt="" />
        </div>
      ) : null}

      <form onSubmit={handleSubmit(onSubmit)} className={Style.FormAddProduct}>
        <div className={Style.selectHolder}>
          {/* {productInput ? (
            <div className={Style.productSelectName}>{productInput}</div>
          ) : ( */}
          <>
            {!onclickPlus ? (
              <FontAwesomeIcon
                icon={faPlus}
                className={Style.plusIcon}
                onClick={() => {
                  setOnclickPlus(true);
                  setOnclickLi(false);
                  setProductInput("");
                }}
              />
            ) : null}
            <input
              className={Style.searchProduct}
              placeholder={" نام محصول"}
              onChange={(e) => getSearchProduct(e.target.value)}
              value={productInput}
            />
          </>
          {/* } */}
          {!showSearchPart ? null : (
            <ul className={Style.searchResult}>
              {searchValue.map((item, index) => {
                return (
                  <li
                    onClick={() => clickProductHandler(item)}
                    className={Style.resultItem}
                    key={index}
                  >
                    <div className={Style.imgHolder}>
                      <img
                        src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                        alt=""
                      />
                    </div>
                    {item.name}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
        {clickHandler}
      </form>
    </div>
  );
};

export default SupermarketProductContainer;
